import { useCallback, useState } from 'react';
import API from 'api/API';
import { OnboardingStatus } from 'api/Responses/SatoResponses';
import { TrayVideo, UpdateTrayVideo } from 'api/Responses/TrayResponses';
import { SelectedSetSelectors, useSelectedSet } from 'context/SelectedSet';

interface HookReturn {
  reviewLoading: boolean;
  reviewVideo: (status: OnboardingStatus.APPROVED | OnboardingStatus.REJECTED, videoTrim?: number[]) => Promise<void>;
}

const useReviewVideo = (video: TrayVideo | null): HookReturn => {
  const { selectedSetState, dispatchSelectedSet } = useSelectedSet();
  const [reviewLoading, setReviewLoading] = useState(false);

  const reviewVideo = useCallback(
    async (status: OnboardingStatus.APPROVED | OnboardingStatus.REJECTED, videoTrim?: number[]): Promise<void> => {
      if (video) {
        setReviewLoading(true);

        try {
          const set = SelectedSetSelectors.selectSelectedSet(selectedSetState);
          const tray = SelectedSetSelectors.selectSelectedTray(selectedSetState);

          const updateVideoObject: UpdateTrayVideo = {
            type: video.type,
            order: video.order,
            status,
          };

          if (videoTrim?.length) {
            updateVideoObject.crop_start = videoTrim[0];
            updateVideoObject.crop_end = videoTrim[1];
          }

          await API.sato.updateVideo(set.code, tray.tray_id, updateVideoObject);

          dispatchSelectedSet({
            type: 'REVIEW_VIDEO',
            payload: {
              status,
              crop_start: updateVideoObject.crop_start,
              crop_end: updateVideoObject.crop_end,
            },
          });
        } catch (e) {
          API.errorHandler(e);
        }

        setReviewLoading(false);
      }
    },
    [video, selectedSetState, dispatchSelectedSet],
  );

  return { reviewVideo, reviewLoading };
};

export default useReviewVideo;
